// Pure UI helpers with NO device-type knowledge.
// Device type display names, grouping and icons come from the server-provided
// catalog (lib/deviceCatalog.js) — never hardcode type aliases here, they drift.

// Battery → color bucket (used everywhere)
export function batteryColor(p) {
  if (p == null) return 'text-ink-muted';
  if (p <= 20) return 'text-terracotta-700';
  if (p <= 40) return 'text-[#b4843f]';
  return 'text-sage-600';
}

// Signal quality bucket from raw RSSI or 0–100 score.
export function signalLabel(score) {
  if (score == null) return { label: '—', cls: 'text-ink-muted' };
  if (score >= 75) return { label: 'Excellent', cls: 'text-sage-600' };
  if (score >= 50) return { label: 'Good', cls: 'text-sage-500' };
  if (score >= 25) return { label: 'Fair', cls: 'text-[#b4843f]' };
  return { label: 'Poor', cls: 'text-terracotta-700' };
}

// RSSI in dBm (BLE). null = not reported, render "—".
export function rssiLabel(dbm) {
  if (dbm == null) return { label: '—', cls: 'text-ink-muted' };
  const label = `${dbm} dBm`;
  if (dbm >= -60) return { label, cls: 'text-sage-600' };
  if (dbm >= -75) return { label, cls: 'text-sage-500' };
  if (dbm >= -85) return { label, cls: 'text-[#b4843f]' };
  return { label, cls: 'text-terracotta-700' };
}
